import React, {useEffect} from 'react';
import {Text} from 'wix-ui-tpa/cssVars';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {PaymentRequestView} from '../PaymentRequestView';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {classes} from './ThankYouView.st.css';
import {SPECS} from '../../../../common/constants';

export enum ThankYouViewDataHook {
  root = 'ThankYouViewDataHook.root',
  view = 'ThankYouViewDataHook.view',
  paymentTitle = 'ThankYouViewDataHook.paymentTitle',
  orderNumber = 'ThankYouViewDataHook.orderNumber',
  amount = 'ThankYouViewDataHook.amount',
}

export const ThankYouView = () => {
  const {
    paymentRequestStore: {paymentRequest, sendPaymentRequestThankYouPageLoadBIEvent},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();
  const {experiments} = useExperiments();
  const usePaymentRequestTitleInThankYou = experiments.enabled(SPECS.UsePaymentRequestTitleInThankYou);
  const orderNumber =
    !usePaymentRequestTitleInThankYou || paymentRequest.orderNumber !== '0' ? paymentRequest.orderNumber : undefined;
  const amountPaid = paymentRequest.total.formattedAmount;
  const title = paymentRequest.title;
  const shouldShowTitle = usePaymentRequestTitleInThankYou && !!title;

  useEffect(
    () => {
      sendPaymentRequestThankYouPageLoadBIEvent();
    },
    /* eslint-disable react-hooks/exhaustive-deps */ []
  );

  return (
    <div data-hook={ThankYouViewDataHook.root}>
      <PaymentRequestView
        dataHook={ThankYouViewDataHook.view}
        title={localeKeys.checkout.payLinks.thankYouPage.title()}
        subtitle={localeKeys.checkout.payLinks.thankYouPage.subtitle()}
      />
      <div className={classes.numberAndAmountContainer}>
        {shouldShowTitle && (
          <Text data-hook={ThankYouViewDataHook.paymentTitle} className={classes.thankYouText}>
            {title}
          </Text>
        )}
        {!shouldShowTitle && orderNumber && (
          <Text data-hook={ThankYouViewDataHook.orderNumber} className={classes.thankYouText}>
            {localeKeys.checkout.payLinks.thankYouPage.orderNumber({incrementalID: orderNumber})}
          </Text>
        )}
        {amountPaid && (
          <Text data-hook={ThankYouViewDataHook.amount} className={classes.thankYouText}>
            {localeKeys.checkout.payLinks.thankYouPage.amountPaid({amountPaid})}
          </Text>
        )}
      </div>
    </div>
  );
};
